module.exports = __webpack_public_path__ + "static/media/599.705493(4).91bc3271.pdf";